import gql from "graphql-tag";

const CREATE_DIMENSION = gql`
  mutation createDimension($productId: ID!, $dimensionData: DimensionInput) {
    createDimension(productId: $productId, dimensionData: $dimensionData)
  }
`;

export default CREATE_DIMENSION;
